module.exports = __webpack_public_path__ + "public/images/slider/speaker-8.a97d85f79859f4c05654843190db02e2.jpg";